import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { TradeInstructionsDetailsGridLayoutService } from "@irb/irb-editors/edit-trading-instructions/trade-details/trade-instructions-details.grid-layout.service";
import { UtilityService } from "@irb-common/services/utility.service";
import { IOrders } from "@irb/irb-orders/irb-orders.model";
import { DialogComponent } from "@irb-common/components/dialog/dialog.component";

@Component({ standalone: false,
  selector: "irb-trade-details",
  templateUrl: "./trade-details.component.html",
  styleUrls: ["./trade-details.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class TradeDetailsComponent implements OnInit {
  _gridOptions: any;
  grid: any;
  openGrid: boolean;
  viewBlockOrder: any;
  blockOrder: IOrders;
  blockOrderGridOptions: any;
  //height: string = "200px";
  gridHeight: string = '180px';
  @ViewChild("viewBlockOrders")
  public blockOrdersTemplate: TemplateRef<any>;
  frameworkComponents: any;
  frameworkDetailComponents: any;

  constructor(private gls: TradeInstructionsDetailsGridLayoutService, private util: UtilityService) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),      
      // embedFullWidthRows: true,
      rowSelection: "multiple",
      floatingFilter: false,
      masterDetail: true,
      rowClass: "white-bg-row",
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No Included Portfolios</span>",
      context: { componentParent: this },
      defaultColDef: {
        flex: 1,
      },
      detailRowAutoHeight: true,
      detailCellRendererParams: (params: any) => ({
        detailGridOptions: {
          columnDefs: this.gls.getDetailColumnDefs(),
          defaultColDef: { flex: 1 },
          suppressHorizontalScroll: true,
          context: {
            componentParent: this,
            masterRowIndex: params.node.rowIndex,
            masterNodeData: params.data,
          },
          components: this.gls.getDetailFrameworkComponents()
        },
        getDetailRowData: (params: any) => {
          // console.log('Details grid params', params);
          let detailRow = this.util.clone(params.data);
          let detailRows = [detailRow];
          params.successCallback(detailRows);

          // this.grid && this.grid.api.forEachDetailGridInfo(function (detailGridInfo: any) {
          //   detailGridInfo.api.sizeColumnsToFit();
          // });
        },
        suppressHorizontralScroll: true
      })
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.frameworkDetailComponents = this.gls.getDetailFrameworkComponents();
  }

  dialog: DialogComponent;
  private _tradeDetails: Array<any>;
  @Input()
  set tradeDetails(value: Array<any>) {
    this._tradeDetails = value;
    this.loadGrid();
  }

  get tradeDetails() {
    return this._tradeDetails;
  }

  ngOnInit(): void {}

  set gridOptions(gridOpns: any) {
    this._gridOptions = gridOpns;
  }

  get gridOptions() {
    return this._gridOptions;
  }

  onGridReady(params: any) {
    //console.log(params);
    this.grid = params;
    this.loadGrid();
  }

  private loadGrid() {
    if (this.grid && this.grid.api) {
      this.grid.api.setGridOption('rowData', this.tradeDetails);

      if (this.tradeDetails.length === 1) {
        setTimeout (() => {
          this.grid.api.getDisplayedRowAtIndex(0).setExpanded(true);
        },0);
      }

      if(this.tradeDetails.length > 10) {
        this.grid.api.setGridOption('domLayout', 'normal');
        this.gridHeight = "332px";
      } else {
        this.grid.api.setGridOption('domLayout', 'autoHeight');
        this.gridHeight = "100%";
      }
    }
  }

  getRowCount() {
    return this._tradeDetails ? this._tradeDetails.length : 0;
  }
  
  blockOrdersDialog(response: any, rowData: IOrders): void {
    this.blockOrder = rowData;
    this.viewBlockOrder = response;
    this.openGrid = true;

    this.blockOrderGridOptions = {
      columnDefs: this.gls.getColumnDefsBlockOrder(),
      skipHeaderOnAutoSize: true,
      floatingFilter: false,
    };

    this.dialog.open(this.blockOrdersTemplate);
  }

  close() {}
}
